export default __webpack_public_path__ + "static/code-snippet@1x-2af66e4db04d0248b4417ca89b86a176.png";